module.exports = __webpack_public_path__ + "media/xanthoma.2a32fde2.wav";